export const SCREEN_SWITCH_STEP_COLLECTION = {
  BEGIN_PUT_TARGET_MINI_INTO_TEMP: "BEGIN_PUT_TARGET_MINI_INTO_TEMP",
  BEGIN_PUT_TARGET_MINI_INTO_TEMP__DEBUG: "BEGIN_PUT_TARGET_MINI_INTO_TEMP__DEBUG",

  TEMP_VIDEO_RESIZE_SHOW_TEMP_VIDEO: "TEMP_VIDEO_RESIZE_SHOW_TEMP_VIDEO",
  TEMP_VIDEO_RESIZE_SHOW_TEMP_VIDEO__DEBUG: "TEMP_VIDEO_RESIZE_SHOW_TEMP_VIDEO__DEBUG",

  XXX: "XXX",
  XXX__DEBUG: "XXX__DEBUG",

  SWITCH_TO_BASE_SCREEN_STREAM: "SWITCH_TO_BASE_SCREEN_STREAM",
  SWITCH_TO_BASE_SCREEN_STREAM__DEBUG: "SWITCH_TO_BASE_SCREEN_STREAM__DEBUG",

  MAIN_VIDEO_RESIZE_SWITCH_TO_TARGET_SCREEN_STREAM: "MAIN_VIDEO_RESIZE_SWITCH_TO_TARGET_SCREEN_STREAM",
  MAIN_VIDEO_RESIZE_SWITCH_TO_TARGET_SCREEN_STREAM__DEBUG: "MAIN_VIDEO_RESIZE_SWITCH_TO_TARGET_SCREEN_STREAM__DEBUG",

  MAIN_VIDEO_RESIZE_SHOW_MAIN_VIDEO: "MAIN_VIDEO_RESIZE_SHOW_MAIN_VIDEO",
  MAIN_VIDEO_RESIZE_SHOW_MAIN_VIDEO__DEBUG: "MAIN_VIDEO_RESIZE_SHOW_MAIN_VIDEO__DEBUG",

  SWITCH_TO_TARGET_SCREEN_STREAM: "SWITCH_TO_TARGET_SCREEN_STREAM",
  SWITCH_TO_TARGET_SCREEN_STREAM__DEBUG: "SWITCH_TO_TARGET_SCREEN_STREAM__DEBUG",

  END_PUT_BASE_MINI_INTO_TEMP: "END_PUT_BASE_MINI_INTO_TEMP",
  END_PUT_BASE_MINI_INTO_TEMP__DEBUG: "END_PUT_BASE_MINI_INTO_TEMP__DEBUG",

  FINISH_LOADING_MAIN_STREAM: "FINISH_LOADING_MAIN_STREAM",
  FINISH_LOADING_MAIN_STREAM__DEBUG: "FINISH_LOADING_MAIN_STREAM__DEBUG",

  INSERT_AN_AUDIO_TRACK: "INSERT_AN_AUDIO_TRACK",
  INSERT_AN_AUDIO_TRACK__DEBUG: "INSERT_AN_AUDIO_TRACK__DEBUG",

  PLAY_AN_AUDIO_TRACK: "PLAY_AN_AUDIO_TRACK",
  PLAY_AN_AUDIO_TRACK__DEBUG: "PLAY_AN_AUDIO_TRACK__DEBUG",
};
